export default __webpack_public_path__ + "static/media/controlRelay.81a49e42.svg";